import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { Button, Modal, Table } from "react-bootstrap";
import { Toaster, toast } from "sonner";
const PackersMoverDetails = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const useQueryParams = () => {
    return new URLSearchParams(search); // Parse the query string
  };

  const queryParams = useQueryParams();

  const service = queryParams.get("service");
  const city = queryParams.get("city");
  const shiftingFrom = queryParams.get("shiftingFrom");
  const shiftingTo = queryParams.get("shiftingTo");
  const shiftingDate = queryParams.get("shiftingDate");
  const lat = queryParams.get("lat");
  const lang = queryParams.get("lang");
  const latto = queryParams.get("latto");
  const langto = queryParams.get("langto");

  const [Subcate, setSubCatList] = useState([]);
  const [Distance, setDistance] = useState(0);

  // Calculate distance between pickup and delivery coords
  useEffect(() => {
    if (lat && lang && latto && langto) {
      const url = `https://router.project-osrm.org/route/v1/driving/${lang},${lat};${langto},${latto}?overview=false`;
      axios.get(url)
        .then((res) => {
          const meters = res.data.routes[0].distance;
          setDistance((meters / 1000).toFixed(2));
        })
        .catch(() => {
          // fallback: straight-line distance in km
          const R = 6371;
          const dLat = ((latto - lat) * Math.PI) / 180;
          const dLon = ((langto - lang) * Math.PI) / 180;
          const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos((lat * Math.PI) / 180) *
              Math.cos((latto * Math.PI) / 180) *
              Math.sin(dLon / 2) *
              Math.sin(dLon / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          setDistance((R * c).toFixed(2));
        });
    }
  }, [lat, lang, latto, langto]);

  const getSubCategory = async () => {
    try {
      let res = await axios.get(
        "https://vrpmpro.com/api/admin/getAllsubcategory"
      );
      if (res.status == 200) {
        setSubCatList(res.data.success);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSubCategory();
  }, []);

  const uniqueCat = [...new Set(Subcate?.map((ele) => ele?.category))];

  const [activeTab, setActiveTab] = useState("addedItems");
  const [dropdowns, setDropdowns] = useState({
    table: false,
    bed: false,
    chair: false,
    kitchenAppliance: false,
    generalAppliance: false,
  });
console.log("dropdowns",dropdowns);

  const toggleDropdown = (item) => {
    setDropdowns((prevState) => ({
      ...prevState,
      [item]: !prevState[item],
    }));
  };
  const [Cart, setCart] = useState([]);
  console.log("cart",Cart);
  const AddToCart = (data) => {
    setCart([...Cart, { ...data, quantity: 1 }]);
  };

  const increment = (ele) => {
    setCart(
      Cart.map((item) => {
        if (item?._id === ele?._id) {
          return { ...item, quantity: item.quantity + 1 };
        }
        return item;
      })
    );
  };
  const removeItem = (ele) => {
    setCart(Cart.filter((item) => item._id !== ele._id));
  };
  const decrement = (ele) => {
    if (Cart.find((item) => item?._id == ele?._id)?.quantity <= 1) {
      removeItem(ele);
    } else
      setCart(
        Cart.map((item) => {
          if (item?._id === ele?._id) {
            return { ...item, quantity: item.quantity - 1 };
          }
          return item;
        })
      );
  };

  const user = JSON.parse(sessionStorage.getItem("user"));
  const [selectedPayment, setSelectedPayment] = useState("");
  const [showp, setShowp] = useState(false);

  // Price calculation for between cities / international
  const calculatePrice = () => {
    if (!Cart.length) return 0;
    // Base price per item × quantity, scaled by distance
    const distanceKm = parseFloat(Distance) || 0;
    const itemTotal = Cart.reduce((sum, item) => sum + item.quantity, 0);
    // ₹500 base + ₹10 per km + ₹200 per item
    const base = 500 + distanceKm * 10 + itemTotal * 200;
    return base.toFixed(2);
  };

  const totalPrice = calculatePrice();
  const handaleSend = async () => {
    if (!user) return toast.error("Please login to proceed");
    if(!shiftingFrom) return toast.error("Please select a shifting from");
    if(!shiftingTo) return toast.error("Please select a shifting to");  
    if(!shiftingDate) return toast.error("Please select a shifting date");
    if (!Cart.length) return toast.error("Your cart is empty");
    try {
      const config = {
        url: "/user/bookings",
        method: "post",
        baseURL: "https://vrpmpro.com/api",
        headers: { "content-type": "application/json" },
        data: {
          customerName: user?.name,
          phone: user?.phonenumber,
          email: user?.email,
          pickupAddress: shiftingFrom,
          deliveryAddress: shiftingTo,
          bookingDate: shiftingDate,
          pickupLat: lat,
          pickupLng: lang,
          deliveryLat: latto,
          deliveryLng: langto,
          city: city,
          setviceType: service,
          totalPrice: parseFloat(totalPrice),
          bookingTime:moment().format("HH:mm"),
          Cart:Cart
          
        },
      };
      let res = await axios(config);
      if (res.status === 201) {
        toast.success("Team will contact you soon", {
          style: { backgroundColor: "#28a745", color: "white" },
        });
        setTimeout(() => {
          window.location.assign("/");
        }, 3000);
      }
      
    } catch (error) {
      console.log(error);
      toast.error("Unable to book please try again");
    }
  };
  return (
    <div className="mt-5" style={{ width: "100%", paddingBottom: "100px" }}>
      <Toaster position="top-center" />
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="card p-3">
              <h5 className="card-title">Add your Inventory</h5>
              <p className="text-muted">
                <i className="fas fa-lightbulb"></i> By providing a list of
                household items, you allow us to provide an accurate cost.
              </p>
              {/* <input
                type="text"
                className="form-control mb-3"
                placeholder="Search for a household item to add"
              /> */}
              <ul className="nav nav-tabs mb-3">
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "addedItems" ? "active" : ""
                    }`}
                    href="#"
                    onClick={() => setActiveTab("addedItems")}
                  >
                    Added Items ({Cart.length})
                  </a>
                </li>
                {uniqueCat?.map((ele) => {
                  return (
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          activeTab === ele ? "active" : ""
                        }`}
                        href="#"
                        onClick={() => setActiveTab(ele)}
                      >
                        {ele}
                      </a>
                    </li>
                  );
                })}
              </ul>
              {Subcate?.filter((ele) => ele?.category === activeTab)?.map(
                (item) => {
                  return (
                    <div className="list-group">
                      <div className="list-group-item">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleDropdown(item?.subcategory)}
                        >
                          <span>{item?.subcategory}</span>
                          <i
                            className={`fas fa-chevron-${
                              dropdowns[item?.subcategory] ? "up" : "down"
                            }`}
                          ></i>
                        </div>
                        {dropdowns[item?.subcategory] && (
                          <div className="dropdown-content ">
                            {item?.subcategoryitems?.map((ele) => (
                              <div className="d-flex justify-content-between align-items-center w-100 gap-5 border p-2">
                                <h5 style={{ fontSize: "16px" }}>
                                  {ele?.itemName}
                                </h5>
                                {Cart?.some((a) => a?._id == ele?._id) ? (
                                  <div
                                    className="d-flex gap-4 align-items-center"
                                    style={{
                                      border: "1px solid black",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    <span
                                      onClick={() => decrement(ele)}
                                      style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      -
                                    </span>
                                    {
                                      Cart?.find((b) => b._id == ele?._id)
                                        ?.quantity
                                    }
                                    <span
                                      onClick={() => increment(ele)}
                                      style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                        paddingRight: "10px",
                                      }}
                                    >
                                      +
                                    </span>
                                  </div>
                                ) : (
                                  <button
                                    className="btn btn-outline-dark"
                                    onClick={() => AddToCart(ele)}
                                  >
                                    Add
                                  </button>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              )}

              {activeTab === "addedItems" && Cart.length > 0 ? (
                <div className="list-group">
                  <div className="list-group-item">
                    <div className="dropdown-content ">
                      {Cart?.map((ele) => (
                        <div className="d-flex justify-content-between align-items-center w-100 gap-5 border p-2">
                          <h5 style={{ fontSize: "16px" }}>{ele?.itemName}</h5>
                          {Cart?.some((a) => a?._id == ele?._id) ? (
                            <div
                              className="d-flex gap-4 align-items-center"
                              style={{
                                border: "1px solid black",
                                borderRadius: "6px",
                              }}
                            >
                              <span
                                onClick={() => decrement(ele)}
                                style={{
                                  fontSize: "24px",
                                  cursor: "pointer",
                                  paddingLeft: "10px",
                                }}
                              >
                                -
                              </span>
                              {Cart?.find((b) => b._id == ele?._id)?.quantity}
                              <span
                                onClick={() => increment(ele)}
                                style={{
                                  fontSize: "24px",
                                  cursor: "pointer",
                                  paddingRight: "10px",
                                }}
                              >
                                +
                              </span>
                            </div>
                          ) : (
                            <button
                              className="btn btn-outline-dark"
                              onClick={() => AddToCart(ele)}
                            >
                              Add
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="alert alert-light mt-3" role="alert">
                Get a video inspection for{" "}
                <span className="badge badge-free">Free</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Total Items - {Cart.length}</span>
                <span className="fw-bold text-danger fs-5">
                  ₹ {Cart.length > 0 ? totalPrice : "0.00"}
                </span>
                <button
                  className="btn btn-danger"
                  onClick={() => handaleSend()}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card p-3">
              <h4>Booking Details</h4>
              <Card className="p-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Booking</h5>
                  {/* <Link to >
                  <p className="text-danger" >Edit</p>
                  </Link> */}
                </div>

                <div>
                  <span className="d-flex gap-2 align-items-center mt-1">
                    <img
                      src="./img/location.png"
                      width={20}
                      alt="From Location"
                    />{" "}
                    {shiftingFrom}
                  </span>
                  <span className="d-flex gap-2 align-items-center mt-3">
                    <img
                      src="./img/location.png"
                      width={20}
                      alt="To Location"
                    />{" "}
                    {shiftingTo}
                  </span>
                  <hr />
                  <div className="d-flex justify-content-between mt-2">
                    <span className="text-muted">Distance</span>
                    <span className="fw-bold">{Distance} km</span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="text-muted">Items</span>
                    <span className="fw-bold">{Cart.length}</span>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span className="text-muted">Estimated Price</span>
                    <span className="fw-bold text-danger">₹ {Cart.length > 0 ? totalPrice : "—"}</span>
                  </div>
                  <p className="text-muted mt-2" style={{ fontSize: "11px" }}>
                    * Final price confirmed by our team
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackersMoverDetails;
